// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

const presence = {
  presence: true,
  message: localizer.getText('COMMON_CONSTRAINT_REQUIRED')
};

export default {
  DEFAULT_TABLE_HEIGHT: 328,
  DEFAULT_REST_HEIGHT: 122,
  DEFAULT_DATABASE_MAPPING_HEIGHT: 238,

  get TableDefinition() {
    return {
      get ImportSourceType() {
        return {
          fileName: {
            columnKey: 'FileName',
            width: 250,
            get title() {
              return localizer.getText('IMPORT_CONSTANTS_SOURCE_TYPE_FILENAME');
            },
            sortable: true
          },
          type: {
            columnKey: 'Type',
            width: 200,
            get title() {
              return localizer.getText('IMPORT_CONSTANTS_SOURCE_TYPE_TYPE');
            },
            sortable: true
          },
          newReportName: {
            columnKey: 'NewReportName',
            width: 300,
            get title() {
              return localizer.getText('IMPORT_CONSTANTS_SOURCE_TYPE_NEW_REPORT_NAME');
            },
            sortable: true
          },
          newReportOrDashboardName: {
            columnKey: 'NewReportName/DashboardName',
            width: 300,
            get title() {
              return localizer.getText('IMPORT_CONSTANTS_SOURCE_TYPE_NEW_REPORT_OR_DASHBOARD_NAME');
            },
            sortable: true
          },
          saveInto: {
            columnKey: 'SaveInto',
            width: 250,
            get title() {
              return localizer.getText('IMPORT_CONSTANTS_SOURCE_TYPE_SAVE_INTO');
            },
            sortable: true
          },
          category: {
            columnKey: 'Category',
            width: 250,
            get title() {
              return localizer.getText('IMPORT_CONSTANTS_SOURCE_TYPE_CATEGORY');
            },
            sortable: true
          },
          subCategory: {
            columnKey: 'SubCategory',
            width: 250,
            get title() {
              return localizer.getText('IMPORT_CONSTANTS_SOURCE_TYPE_SUB_CATEGORY');
            },
            sortable: true
          },
          gear: {
            columnKey: 'Gear',
            width: 60,
            title: '',
            sortable: true
          }
        };
      },

      get DatabaseMappingSourceType() {
        return {
          physicalDatabase: {
            columnKey: 'PhysicalDatabase',
            width: 150,
            get title() {
              return localizer.getText('DATABASE_MAPPING_PHYSICAL_DATABASE');
            },
            sortable: true
          },
          databaseName: {
            columnKey: 'DatabaseName',
            width: 150,
            get title() {
              return localizer.getText('DATABASE_MAPPING_DATABASE_NAME');
            },
            sortable: true
          },
          schema: {
            columnKey: 'Schema',
            width: 150,
            get title() {
              return localizer.getText('DATABASE_MAPPING_SCHEMA');
            },
            sortable: true
          },
          action: {
            columnKey: 'Action',
            width: 50,
            get title() {
              return localizer.getText('DATABASE_MAPPING_ACTION');
            },
            sortable: true
          }
        };
      },

      get ReportInformation() {
        return {
          shareWith: {
            columnKey: 'ShareWith',
            width: 450,
            get title() {
              return localizer.getText('COMMON_LABEL_SHARE_WITH');
            },
            sortable: true
          },
          accessRights: {
            columnKey: 'AccessRights',
            width: 150,
            get title() {
              return localizer.getText('COMMON_LABEL_ACCESS_RIGHT');
            },
            sortable: true
          }
        };
      }
    };
  },

  getReportType(reportType) {
    return reportType === 0 ? 'Report' : 'Template';
  },

  // Import List
  KEY_NEW_REPORT_NAME: 'newReportName',
  KEY_NEW_REPORT_DASHBOARD_NAME: 'newReportDashboardName',
  KEY_SAVE_INTO: 'saveInto',
  KEY_CATEGORY: 'category',
  KEY_SUBCATEGORY: 'subCategory',

  // Database Mapping List
  KEY_TO_DATABASE_NAME: 'toDatabaseName',
  KEY_TO_SCHEMA: 'toSchema',

  REQUIRED_VALIDATION_RULES: {
    presence: {
      presence: true,
      message: localizer.getText('COMMON_CONSTRAINT_REQUIRED')
    },
    format: {
      pattern: /^[^/<>&]*$/,
      get message() {
        return localizer.getText('INVALID_TEMPLATE_NAME');
      }
    }
  },
  FILE_EXTENSION: {
    REPORT: '.birt',
    DASHBOARD: '.bidb'
  },
  REPORT_NAME_VALIDATION_RULES: {
    presence: presence,
    format: {
      pattern: /^[^/<>&]*$/,
      get message() {
        return localizer.getText('INVALID_REPORT_NAME');
      }
    }
  },
  TEMPLATE_NAME_VALIDATION_RULES: {
    presence: presence,
    format: {
      pattern: /^[^/<>&]*$/,
      get message() {
        return localizer.getText('INVALID_TEMPLATE_NAME');
      }
    }
  },
  DASHBOARD_NAME_VALIDATION_RULES: {
    presence: presence,
    format: {
      pattern: /^[^/<>&]*$/,
      get message() {
        return localizer.getText('INVALID_DASHBOARD_NAME');
      }
    }
  },

  IMPORT_PROGRESS_LIST_MAX_HEIGHT: 300,
  get ImportStatus() {
    return {
      NOT_PROCESSED: { value: 0, label: localizer.getText('IMPORT_STATUS_NOT_PROCESSED') },
      SUCCESS: { value: 1, label: localizer.getText('IMPORT_STATUS_SUCCESS') },
      FAILED: { value: 2, label: localizer.getText('IMPORT_STATUS_FAILED') },
      CANCELED: { value: 3, label: '' },
      IN_PROGRESS: { value: 4, label: '' }
    };
  },
  IMPORT_STATUS_REFRESH_INTERVAL: 2000,

  // KEY TYPES TITLE
  TYPE_REPORT: 1,
  TYPE_DASHBOARD: 2,

  // KEY TYPE TO LOAD ACCESS RIGHTS
  TYPE_ACCESS_REPORT: 0,
  TYPE_ACCESS_DASHBOARD: 1,

  get TitlesData() {
    return {
      get settingLevel() {
        return localizer.getText('IMPORT_SETTING_LEVEL');
      },
      get databases() {
        return localizer.getText('IMPORT_DATABASES');
      },
      get dataSources() {
        return localizer.getText('IMPORT_DATA_SOURCES');
      },
      get customViews() {
        return localizer.getText('IMPORT_CUSTOM_VIEWS');
      },
      get calculatedFields() {
        return localizer.getText('IMPORT_CALCULATED_FIELDS');
      }
    };
  },

  HINT_MESSAGE: {
    get CATEGORY() {
      return localizer.getText('REPORTDESIGNER_MESSAGE_HINT_CATEGORY');
    },
    get SUB_CATEGORY() {
      return localizer.getText('REPORTDESIGNER_MESSAGE_HINT_SUB_CATEGORY');
    }
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ImportConstants.js